/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Patrol_Places_HintInputs */

const en_dispatch_patrol_places_hint = /** @type {(inputs: Dispatch_Patrol_Places_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least 2 waypoints`)
};

const fr_dispatch_patrol_places_hint = /** @type {(inputs: Dispatch_Patrol_Places_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne au moins 2 waypoints`)
};

const ms_sg2_dispatch_patrol_places_hint = /** @type {(inputs: Dispatch_Patrol_Places_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih sekurang-kurangnya 2 titik laluan`)
};

/**
* | output |
* | --- |
* | "Pick at least 2 waypoints" |
*
* @param {Dispatch_Patrol_Places_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_patrol_places_hint = /** @type {((inputs?: Dispatch_Patrol_Places_HintInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Patrol_Places_HintInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_patrol_places_hint(inputs)
	if (locale === "fr") return fr_dispatch_patrol_places_hint(inputs)
	return ms_sg2_dispatch_patrol_places_hint(inputs)
});